// extracted by mini-css-extract-plugin
export default {"productsMenu":"ProductsToolbar_productsMenu__Rvg2T","productsMenuLeft":"ProductsToolbar_productsMenuLeft__sOovr"};